/* Lunatic — sélection de variantes sur la fiche produit (vanilla JS) */
(function () {
  function init(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var optCount = parseInt(root.getAttribute('data-options') || '1', 10);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var mainImg = root.querySelector('[data-main-img]');
    var money = root.getAttribute('data-money') || '€{{amount}}';

     function fmt(cents) {
      var amount = cents / 100;
      var withComma = amount.toFixed(2).replace('.', ',');
      var withDot = amount.toFixed(2);
      var noDec = Math.round(amount);
      return money
        .replace(/\{\{\s*amount\s*\}\}/g, withDot)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec);
    }

    // état sélectionné = options de la 1re variante dispo
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var selected = first ? first.options.slice() : [];

    function matching() {
      return variants.find(function (v) {
        for (var i = 0; i < optCount; i++) { if (v.options[i] !== selected[i]) return false; }
        return true;
      });
    }

    function valueAvailable(optIndex, value) {
      return variants.some(function (v) {
        if (v.options[optIndex] !== value) return false;
        for (var i = 0; i < optCount; i++) { if (i !== optIndex && v.options[i] !== selected[i]) return false; }
        return v.available;
      });
    }

    function render() {
      // marquer la sélection + dispo
      root.querySelectorAll('[data-opt]').forEach(function (btn) {
        var oi = parseInt(btn.getAttribute('data-opt'), 10);
        var val = btn.getAttribute('data-val');
        btn.classList.toggle('sel', selected[oi] === val);
        var ok = valueAvailable(oi, val);
        btn.classList.toggle('out', !ok);
        btn.disabled = false; // on laisse cliquable pour changer la combinaison
      });
      // libellé option courante
      root.querySelectorAll('[data-opt-label]').forEach(function (lab) {
        var oi = parseInt(lab.getAttribute('data-opt-label'), 10);
        lab.textContent = selected[oi] || '';
      });
      var v = matching();
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = fmt(v.compare_at_price); compareEl.style.display = '';
          } else { compareEl.style.display = 'none'; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.getAttribute('data-label') || 'Ajouter au panier') : 'Épuisé';
        }
        if (mainImg && v.featured_image && v.featured_image.src) {
          mainImg.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
        }
      }
    }

    root.querySelectorAll('[data-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var oi = parseInt(btn.getAttribute('data-opt'), 10);
        selected[oi] = btn.getAttribute('data-val');
        render();
      });
    });

    // miniatures galerie
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.getAttribute('data-full');
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('sel'); });
        t.classList.add('sel');
      });
    });

    render();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-variant-picker]').forEach(init);
  });
})();
